





























import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import BaseButtonDropdown from '@/modules/shared/components/shared/kit/BaseButtonDropdown.vue'
import { Prop } from 'vue-property-decorator'
import { AdminContentItemRoutes } from '@/modules/content-item/routes/admin-content-item.route'
import BaseButton from '@/modules/shared/components/shared/kit/BaseButton.vue'
import { ContentFormat } from '@/modules/content/models/content-resource.model'

@Component({
  components: { BaseButtonDropdown, BaseButton }
})
export default class AdminContentItemDownloadContent extends Vue {
  @Prop() contentItemId: number
  @Prop({ default: 'دانلود محتوا' }) label: string
  @Prop({ default: () => [ContentFormat.HTML, ContentFormat.WORD, ContentFormat.PDF, ContentFormat.ZIP] }) formatList: string[]
  @Prop({ default: 'admin' }) userType: string
  icons: Record<ContentFormat, string> = {
    [ContentFormat.HTML]: 'fal fa-file-code',
    [ContentFormat.WORD]: 'fal fa-file-word',
    [ContentFormat.PDF]: 'fal fa-file-pdf',
    [ContentFormat.ZIP]: 'fal fa-file-zipper'
  }

  constructor(
    private readonly adminContentItemRoutes: AdminContentItemRoutes
  ) {
    super()
  }

  getRoute(format) {
    return this.adminContentItemRoutes.downloadContent(this.contentItemId, format)
  }

}
